import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

// Read directly from build-time environment variables
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

if (!process.env.REACT_APP_SOCKET_URL) {
  console.warn('REACT_APP_SOCKET_URL is not set. Falling back to default: ', SOCKET_URL);
}

export const connectSocket = (token: string): void => {
    if (socket?.connected) {
        console.log('Socket already connected.');
        return;
    }

    console.log('Attempting to connect socket...', SOCKET_URL);
    // Disconnect previous instance if exists but not connected properly
    if(socket) {
        socket.disconnect();
    }

    socket = io(SOCKET_URL, {
        // Send auth token for backend authentication
        auth: {
            token
        },
        // Optional: configure transports, reconnection attempts, etc.
        reconnectionAttempts: 5,
        reconnectionDelay: 3000,
    });

    socket.on('connect', () => {
        console.log('Socket connected successfully! ID:', socket?.id);
    });

    socket.on('disconnect', (reason) => {
        console.log('Socket disconnected:', reason);
        // Handle disconnection logic if needed (e.g., show message)
        // Important: server shutting down might be 'io server disconnect'
    });

    socket.on('connect_error', (error) => {
        console.error('Socket connection error:', error);
        // Handle connection errors (e.g., authentication failure)
    });

    // Example: Generic listener for server messages/errors (optional)
    socket.on('server_message', (data) => {
        console.log('Message from server:', data);
    });
};

export const disconnectSocket = (): void => {
    if (socket) {
        console.log('Disconnecting socket...');
        socket.disconnect();
        socket = null;
    }
};

// Function to emit events
export const emitEvent = (eventName: string, data: any): void => {
    if (socket?.connected) {
        socket.emit(eventName, data);
    } else {
        console.error('Socket not connected. Cannot emit event:', eventName);
        // Maybe queue the event or show an error
    }
};

// Function to register event listeners
export const registerListener = (eventName: string, callback: (...args: any[]) => void): (() => void) => {
    if (socket) {
        console.log(`[socketService] Registering listener for event: '${eventName}'`);
        // Define the actual listener function
        const listener = (...args: any[]) => {
            console.log(`[socketService] Received event '${eventName}' with data:`, args);
            callback(...args);
        };
        // Attach the listener
        socket.on(eventName, listener);
        
        // Return a cleanup function
        return () => {
            console.log(`[socketService] Cleaning up listener for event: '${eventName}'`);
            socket?.off(eventName, listener);
        };
    } else {
        console.error('[socketService] Socket not initialized. Cannot register listener:', eventName);
        return () => {}; // Return an empty cleanup function
    }
};

// Function to remove a specific listener (if cleanup function isn't used)
export const removeListener = (eventName: string, callback: (...args: any[]) => void): void => {
    socket?.off(eventName, callback);
};

// Check if socket is currently connected
export const isSocketConnected = (): boolean => {
    return socket?.connected || false;
}; 